import { css } from "lit";
export const componentStyles = css `
:host {
  --job-search-background-color: var(--xdlColorXING);
  --job-search-color: var(--xdlPalettePetrol12);
  background-color: var(--job-search-background-color);
  color: var(--job-search-color);
  display: -ms-grid;
  display: grid;
  place-items: center;
  height: 100%;
  font-family: var(--font-brand-sans-stack);
}

h3 {
  font-family: var(--font-brand-bold-stack);
}

form {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  position: relative;
  max-width: 700px;
  margin-inline: auto;
  width: min(700px, 95%);
  gap: var(--spaceL);
}

button[type="submit"] {
  background-color: var(--xdlColorButtonStrong);
  color: var(--xdlPaletteWhite);
  border-radius: var(--spaceXL);
  padding-block: var(--spaceM);
  padding-inline: var(--spaceXL);
  font-weight: 700;
  font-size: calc(14/16 * 1rem);
  line-height: 0.94;
  border: 0;
  font-family: var(--font-brand-bold-stack);
}

button[type="submit"]:hover {
  background-color: var(--xdlPaletteGrayPlain10);
}

input[type="search"] {
  background-color: var(--xdlColorBackground);
  color: var(--xdlColorTextTertiary);
  font-family: var(--font-brand-sans-stack);
  border-radius: var(--spaceXL);
  padding-block: var(--spaceM);
  -webkit-padding-start: calc(24px + 2rem);
          padding-inline-start: calc(24px + 2rem);
  -webkit-padding-end: 1rem;
          padding-inline-end: 1rem;
  font-size: calc(14/16 * 1rem);
  line-height: 1.27;
  border: none;
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}

.input-leading-icon {
  inset-block-start: 50%;
  -webkit-margin-end: 8px;
          margin-inline-end: 8px;
  position: absolute;
  -webkit-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
          transform: translateY(-50%);
  height: 24px;
  width: 24px;
  color: var(--xdlColorTextTertiary);
  inset-inline-start: 20px;
  display: block;
}

@media (max-width: 1279px){
  form {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }

  .input-leading-icon {
    inset-block-start: 22px;
  }
}
`;
//# sourceMappingURL=job-search.css.js.map